
export default function NotFound() {
  return (
	<div className="light-jq text-center p-3">
		<h1> Website im Aufbau </h1>
	</div>
  );
}
